import { lazy, Suspense, type FC, type ComponentProps } from 'react';
import { LoadingComponent } from '../../../components/global/LoadingComponent';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';

const PdpSharedShippingAndReturnsModalLazy = lazy(
    () =>
        import(
            /* webpackChunkName: "PdpSharedShippingAndReturnsModal" */
            './PdpSharedShippingAndReturnsModal'
        )
);

const PdpSharedShippingAndReturnsModalLoader: FC<
    ComponentProps<typeof PdpSharedShippingAndReturnsModalLazy>
> = props => {
    if (!props.isOpened) {
        return null;
    }

    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={<LoadingComponent />}>
                <PdpSharedShippingAndReturnsModalLazy {...props} />
            </Suspense>
        </ErrorBoundary>
    );
};

export { PdpSharedShippingAndReturnsModalLoader };
